export default {
    header: "Ordens de {name}",
    error: "Ocorreu um erro",
    empty: "Nenhum pedido encontrado",
    system: "Central de Ajuda",
    orders: {
        name: "Nome",
        date: "Data",
        status: "Status",
        approvedBy: "Aprovado por"
    },
    cta: {
        close: "Fechar"
    }
}